var staticStrLast = 'last'

module.exports = staticStrLast



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticStrLast.js
// module id = qTg+
// module chunks = 137